package com.wintermar.inspection.feature.presentation.inspection.answer.modal_state

import com.wintermar.inspection.feature.domain.model.answer.SummaryAnswerModel

data class ModalInCompleteState(
    val show: Boolean = false,
    val unAnswerList: List<SummaryAnswerModel> = emptyList(),
    val needDocumentList: List<SummaryAnswerModel> = emptyList()
)
